import { render, staticRenderFns } from "./CalendarSlider.vue?vue&type=template&id=376dbb0d&scoped=true&"
import script from "./CalendarSlider.vue?vue&type=script&lang=js&"
export * from "./CalendarSlider.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSlider.vue?vue&type=style&index=0&id=376dbb0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376dbb0d",
  null
  
)

export default component.exports